/** The callout's default look — shared by the callouts themselves and the guide that places one. */
export const CALLOUT_BG = '#f8c471'
export const CALLOUT_TEXT = '#1a1a1a'
/** On dark theme the bubble is a deep amber, so the default text there is white (PROD-3132). */
export const CALLOUT_TEXT_DARK = '#ffffff'

/**
 * A callout's text colour. Unset, or still the old fixed default every callout used to be
 * saved with, it follows the theme; any colour the trader picked is kept as is.
 */
export function calloutText(color: string | undefined, isDark: boolean): string {
  if (color && color.toLowerCase() !== CALLOUT_TEXT) return color
  return isDark ? CALLOUT_TEXT_DARK : CALLOUT_TEXT
}
